import { Component } from "vue";

const files = require.context(".", false, /\.vue$/);

const modules: Array<{ name: string; component: Component }> = [];
files.keys().forEach((key: string) => {
  modules.push({
    name: key.replace(/(\.\/|\.vue)/g, ""),
    component: files(key).default,
  });
});

export default modules;
